<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <circle class="a" cx="12" cy="12" r="11.25" />

        <circle class="a" cx="12" cy="12" r="8.25" />

        <path
            class="a"
            d="M20.1,10.444A24.951,24.951,0,0,0,12,9a24.936,24.936,0,0,0-8.1,1.444"
        />

        <path class="a" d="M3.881,13.475c3.617-.659,6.5,1.5,5.908,6.475" />

        <path class="a" d="M20.119,13.475c-3.617-.659-6.5,1.5-5.908,6.475" />

        <path class="a" d="M12,12a.375.375,0,0,1,.375.375" />

        <path class="a" d="M11.625,12.375A.375.375,0,0,1,12,12" />

        <path class="a" d="M12,12.75a.375.375,0,0,1-.375-.375" />

        <path class="a" d="M12.375,12.375A.375.375,0,0,1,12,12.75" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'SteeringWheelIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
